module.exports = __webpack_public_path__ + "img/CIUDADANO_MOV.4945efef.svg";